/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Action } from '@rematch/core';
import type { Dispatch } from 'redux';
import { Subject } from 'rxjs';

import { bindRequest } from '../api/bindRequest';
import type { EffectParams, Model, ModelEffects, RootState, Store } from '../types';

const createEffectPlugin = () => {
  const actions: EffectParams['actions'] = new Subject();
  const bagEffects: Record<string, (payload: any, params: RootState) => void> = {};

  return {
    config: {
      redux: {
        middlewares: [
          (store: Store) => (next: Dispatch) => (action: Action) => {
            const result = next(action);
            actions.next({ ...action, state: store.getState() });
            return result;
          }
        ]
      }
    },

    onModel(model: Model<any, void, void, ModelEffects<any>> & { name: string }, store: Store) {
      const { name, effects } = model;
      const { dispatch } = store;
      const request = bindRequest(store);

      if (!effects) return;

      if (typeof effects === 'function') {
        throw new Error(
          'Model effects must be plain objects, global dispatch is provided to each effect.'
        );
      }

      Object.entries(effects).forEach(([effectName, effect]) => {
        bagEffects[`${name}/${effectName}`] = (payload: any, rootState: RootState) =>
          effect(payload, { actions, dispatch, rootState, select: store.select, store, request });
      });
    },

    onStoreCreated(store: Store, bag: any) {
      bag.effects = bagEffects;
    }
  };
};

export default createEffectPlugin;
